import React, { FC, useCallback, useMemo } from 'react';
import key from 'weak-key';
import { ModalName, useToggleModalsContext } from '@/common/contexts/globalModalContext';
import {
  BulletDescriptionPopupProps,
  CareerPopupType,
  ImagePopupProps,
  MembersPopupProps,
  PopupCardProps,
  SimpleBulletPopupProps,
  TextsPopupProps,
} from '@/pages/CareersPage/CareersPage.types';
import classNames from 'classnames';
import ImagePopup from '@/pages/CareersPage/components/popups/ImagePopup/ImagePopup';
import BulletDescriptionPopup
  from '@/pages/CareersPage/components/popups/BulletDescriptionPopup/BulletDescriptionPopup';
import SimpleBulletPopup from '@/pages/CareersPage/components/popups/SimpleBulletPopup/SimpleBulletPopup';
import TextsPopup from '@/pages/CareersPage/components/popups/TextsPopup/TextsPopup';
import MembersPopup from '@/pages/CareersPage/components/popups/MembersPopup/MembersPopup';
import grid from '@/common/css/grid.module.scss';
import styles from './PopupCard.module.scss';

const PopupCard: FC<PopupCardProps> = (props) => {
  const {
    title,
    description,
    hoverColor,
    popupType,
  } = props;

  const popupKey = key(props);

  const renderPopup = useMemo(() => {
    const propsWithKey = { ...props, popupKey };

    switch (popupType) {
      case (CareerPopupType.ImagePopup):
        return <ImagePopup {...propsWithKey as ImagePopupProps} />;
      case (CareerPopupType.BulletDescriptionPopup):
        return <BulletDescriptionPopup {...propsWithKey as BulletDescriptionPopupProps} />;

      case (CareerPopupType.SimpleBulletPopup):
        return <SimpleBulletPopup {...propsWithKey as SimpleBulletPopupProps} />;

      case (CareerPopupType.TextsPopup):
        return <TextsPopup {...propsWithKey as TextsPopupProps} />;

      case (CareerPopupType.MembersPopup):
        return <MembersPopup {...propsWithKey as MembersPopupProps} />;
      default:
        return null;
    }
  }, [
    popupKey, popupType, props,
  ]);

  const toggleModal = useToggleModalsContext();

  const showPopup = useCallback((): void => {
    toggleModal({ [ModalName.careers]: true }, { popupKey });
  }, [popupKey, toggleModal]);

  return (
    <>
      <div className={classNames(styles.wrapper, grid.colSm6, grid.colMd4)}>
        <div className={classNames(styles.card, styles[`hoverColor-${hoverColor}`])} onClick={showPopup}>
          <div className={styles.titleWrapper}>
            <div className={styles.title}>{title}</div>
          </div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
      {renderPopup}
    </>
  );
};
PopupCard.displayName = 'PopupCard';

export default PopupCard;
